import { TESTIMONIALS } from "../../data/home";
import type { Testimonial } from "../../types";

export default function TestimonialsSection() {
  return (
    <section className="bg-fog py-24 px-5 lg:px-16" id="reviews">
      <div className="max-w-6xl mx-auto">
        {/* Section label strip */}
        <div className="flex items-center gap-3 mb-5">
          <span className="font-syne text-[10px] font-bold tracking-[0.28em] uppercase text-ink-20">Client Love</span>
          <span className="flex-1 h-px bg-ink-10" />
        </div>
        <h2
          className="font-syne font-extrabold text-ink tracking-tight leading-none"
          style={{ fontSize: 'clamp(2.5rem,4vw,4rem)' }}
        >
          What People Say
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-12">
          {TESTIMONIALS.map((t) => (
            <TestimonialCard key={t.name + t.context} testimonial={t} />
          ))}
        </div>
      </div>
    </section>
  );
}

function TestimonialCard({ testimonial }: { testimonial: Testimonial }) {
  return (
    <div className="bg-white border border-ink-6 rounded-xl p-8 hover:border-violet/25 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-ink/8 transition-all relative overflow-hidden">
      <span
        className="font-serif italic font-light text-[6rem] text-gold/20 absolute top-2 right-4 leading-none pointer-events-none"
        aria-hidden="true"
      >
        "
      </span>

      <div className="flex gap-1 mb-4">
        {Array.from({ length: 5 }).map((_, i) => (
          <span key={i} className="text-gold text-sm">★</span>
        ))}
      </div>

      <blockquote className="font-serif italic text-ink-55 leading-[1.7] text-base mb-6">
        "{testimonial.quote}"
      </blockquote>

      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-fog border-2 border-violet/20 flex items-center justify-center text-base">
          {testimonial.avatar}
        </div>
        <div>
          <p className="font-syne font-bold text-ink text-sm">{testimonial.name}</p>
          <p className="text-ink-35 text-xs mt-0.5">{testimonial.context}</p>
        </div>
      </div>
    </div>
  );
}
